<template>
  <div class="shop-qrcode-page" :class = "{'clear-header':isWechatBrowser}">
    <my-header class="top-title" v-if="!isWechatBrowser" title="咨询" :showBack="true"></my-header>
    <img class="img-qrcode" :src="shopQrcode">
    <div>点击图片进行查看或者保存到本地</div>
  </div>
</template>

<script>
  import Header from '../../components/header/Header'
  import {imgUrl} from "../../config";

  export default {
    name: 'ShopQrcode',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        imgUrl: imgUrl,
        shopQrcode:'',
        isWechatBrowser:this.$verfyBrowserType(),
      }
    },
    created(){
      this.shopQrcode = this.$route.query.shopQrcode;
    },
    beforeMount () {
      document.title = this.$route.meta.title;
    },
    methods: {
    }
  }
</script>
<style lang="scss">
  @import '../../assets/style/common.scss';
  .shop-qrcode-page{
    font-size: 0.3rem;
    text-align: center;
    height: 100vh;
    background-color: #f3f8fc;

    .img-qrcode{
      margin-top: 1rem;
      width: 5rem;
      height: 5rem;
    }
  }
</style>
